<template>
        <span v-if="!editable">{{formattedDate}}</span>
        <flat-pickr class="flat-pickr" v-else v-bind:value="value"
                    @on-change="change"
                    placeholder="Date"
                    :config="{ placeholder: 'Date', altInput: true, altFormat: 'F j, Y' , dateFormat: 'Y-m-d', allowInput: true}"/>
</template>

<script>
  import {DateTime} from "luxon";

  export default {
    name: "EditableDate",
    props: {
      editable: Boolean,
      value: String
    },
    methods: {
      change(selectedDates, dateStr) {
        this.$emit('input', dateStr)
      }
    },
    computed: {
      formattedDate() {
        return this.value && DateTime.fromISO(this.value).toLocaleString(DateTime.DATE_FULL);
      }
    }
  }
</script>

<style lang="scss">
        //TODO do this better and scoped
        .flat-pickr {
                text-align: center;
                margin-bottom: 0.35em;
                width: 12em;
        }
</style>
